import style from "../components/common.module.css";

import Header from "../components/Header";
import Footer from "../components/Footer";

export default () => {
    return (
        <>
            <div className={style["container"]}>
                <Header />
                <div className={style["wrapper--content"]}>
                    <section>
                        <h1>개인정보 동의서</h1>

                        <p>
                            <strong>디엔지니어(The Engineer)</strong>(이하 “회사”)는 「개인정보보호법」, 「정보통신망
                            이용촉진 및 정보보호 등에 관한 법률」, 「위치정보의 보호 및 이용 등에 관한 법률」 등 관련
                            법령상의 개인정보 보호규정을 준수하며, 개인정보 처리방침을 정하여 이용자 권익 보호에 최선을
                            다하고 있습니다.
                        </p>

                        <h2>1. 개인정보 수집 및 이용 현황</h2>
                        <ul>
                            <li>
                                <strong>수집방법:</strong> 지원사업 신청서
                            </li>
                            <li>
                                <strong>수집항목:</strong> 이메일, 이름, 휴대폰번호, 주소, 제품명
                            </li>
                            <li>
                                <strong>수집 및 이용목적:</strong>
                                <ul>
                                    <li>본인 확인 및 지원의사 확인</li>
                                    <li>신규 서비스 안내, 설문, 상담 및 문의처리</li>
                                </ul>
                            </li>
                            <li>
                                <strong>(선택) 마케팅 정보 수신 동의 항목:</strong>
                                <ul>
                                    <li>이메일, SMS/MMS, push</li>
                                    <li>상품 및 서비스 안내, 설문, 이벤트, 제휴 광고 등</li>
                                </ul>
                            </li>
                        </ul>

                        <h2>2. 개인정보 제3자 제공</h2>
                        <p>
                            회사는 고지한 범위 내에서만 개인정보를 이용하며, 원칙적으로 제3자에게 제공하지 않습니다.
                            다만 다음의 경우 예외로 합니다.
                        </p>
                        <ul>
                            <li>이용자가 서비스 이용 중 제3자 제공에 동의한 경우</li>
                            <li>법령에 의거하거나 수사기관의 요청이 있는 경우</li>
                        </ul>
                        <p>
                            ※ 동의하지 않을 경우 일부 서비스 이용이 제한될 수 있으며, 동의는 언제든지 철회 가능합니다.
                        </p>

                        <h2>3. 개인정보 처리위탁</h2>
                        <table cellSpacing="0" cellPadding="6">
                            <thead>
                                <tr>
                                    <th>수탁업체</th>
                                    <th>위탁업무 내용</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>㈜토스페이먼츠</td>
                                    <td>결제처리 (신용카드, 휴대폰결제, 간편결제)</td>
                                </tr>
                                <tr>
                                    <td>나이스평가정보㈜</td>
                                    <td>휴대폰 및 아이핀 본인인증</td>
                                </tr>
                            </tbody>
                        </table>
                        <p>※ 위탁사항이 변경될 경우 사전 공지 예정</p>

                        <h2>4. 개인정보 보유 및 이용기간</h2>
                        <p>
                            개인정보는 수집·이용 목적 달성 전 또는 탈퇴 요청 시까지 보유되며, 법령에 따라 다음과 같이
                            보관됩니다.
                        </p>

                        <h3>▪ 관련 법령에 따른 보유 기간</h3>
                        <ul>
                            <li>
                                <strong>통신비밀보호법:</strong> 서비스 이용기록, 접속로그, IP (3개월)
                            </li>
                            <li>
                                <strong>전자상거래법:</strong>
                                <ul>
                                    <li>표시/광고: 6개월</li>
                                    <li>계약/청약철회: 5년</li>
                                    <li>대금결제/재화 공급: 5년</li>
                                    <li>소비자 불만 및 분쟁처리: 3년</li>
                                </ul>
                            </li>
                            <li>
                                <strong>부가가치세법:</strong> 거래내역 관련 정보: 5년
                            </li>
                        </ul>

                        <h3>▪ 부정 사용자 차단 목적</h3>
                        <ul>
                            <li>탈퇴 후 1년간 보관</li>
                            <li>보유정보: 컨설팅 1기 지원 내역, 서비스 이용 내역</li>
                        </ul>

                        <h2>5. 개인정보 파기절차 및 방법</h2>
                        <h3>▪ 파기절차 및 기한</h3>
                        <p>
                            수집·이용 목적이 달성된 개인정보는 지체없이 파기됩니다. 관련 법령에 따라 보관해야 할
                            경우에는 별도 DB에 분리 보관 후 일정 기간 경과 시 파기됩니다.
                        </p>

                        <h3>▪ 파기방법</h3>
                        <ul>
                            <li>전자파일: 복구 불가능한 방식으로 삭제</li>
                            <li>종이문서: 분쇄 또는 소각</li>
                        </ul>

                        <h2>6. 개인정보의 보호조치</h2>
                        <h3>▪ 기술적 보호조치</h3>
                        <ul>
                            <li>비밀번호 및 파일 암호화</li>
                            <li>백신 프로그램 사용 및 업데이트</li>
                            <li>SSL 암호화 전송</li>
                            <li>침입차단시스템 적용</li>
                        </ul>

                        <h3>▪ 관리적 보호조치</h3>
                        <ul>
                            <li>개인정보 처리 인원 최소화 및 교육 실시</li>
                            <li>보안서약서 및 내부 관리 절차 운영</li>
                            <li>입퇴사 시 보안 관리 철저</li>
                            <li>전산실 및 자료보관실 출입 통제</li>
                            <li>사고 발생 시 즉각 통보 및 대책 마련</li>
                        </ul>

                        <h2>7. 개인정보 보호책임자 및 고충처리</h2>
                        <ul>
                            <li>
                                <strong>책임자:</strong> 대표 박명호
                            </li>
                            <li>
                                <strong>연락처:</strong> the-engineer@naver.com
                            </li>
                        </ul>

                        <h3>▪ 관련 기관 문의처</h3>
                        <ul>
                            <li>
                                개인정보침해신고센터: 국번없이 118 /{" "}
                                <a href="https://privacy.kisa.or.kr">privacy.kisa.or.kr</a>
                            </li>
                            <li>
                                개인정보 분쟁조정위원회: 1833-6972 /{" "}
                                <a href="https://www.kopico.go.kr">www.kopico.go.kr</a>
                            </li>
                            <li>
                                대검찰청 사이버수사과: 국번없이 1301 / <a href="https://www.spo.go.kr">www.spo.go.kr</a>
                            </li>
                            <li>
                                경찰청 사이버수사국: 국번없이 182 /{" "}
                                <a href="https://ecrm.cyber.go.kr">ecrm.cyber.go.kr</a>
                            </li>
                        </ul>

                        <h2>8. 기타 안내</h2>
                        <p>
                            본 방침은 <strong>2025년 5월 20일</strong>부터 시행되며, 변경 시 홈페이지 또는 이메일을 통해
                            사전 공지됩니다.
                        </p>

                        <p>
                            <strong>버전 정보:</strong> Ver 1.00
                        </p>
                        <p>
                            <strong>시행일자:</strong> 2025년 05월 20일
                        </p>
                    </section>
                </div>
                <Footer />
            </div>
        </>
    );
};
